import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Chart, registerables } from 'chart.js'
import axios from 'axios'
import VueResizeObserver from 'vue-resize-observer'
import { faAlignCenter, faAlignJustify, faAlignLeft, faAlignRight, faAngleDoubleRight, faAngleDown, faArrowLeftLong, faArrowPointer, faArrowRightFromBracket, faArrowsMaximize, faBars, faBarsSort, faBell, faBinoculars, faBookOpenCover, faBookmark, faBringFront, faCalendar, faCartShopping, faChalkboard, faChartPie, faCheck, faCheckDouble, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCircle, faCirclePlus, faClapperboardPlay, faClone, faCloudArrowDown, faCloudArrowUp, faColumns, faComment, faCommentEdit, faComments, faCopy, faCrop, faDash, faDatabase, faDistributeSpacingHorizontal, faDistributeSpacingVertical, faDownload, faEdit, faEllipsisStroke, faEllipsisStrokeVertical, faEllipsisVertical, faEnvelope, faEnvelopeOpen, faExchange, faExclamation, faExclamationTriangle, faEye, faEyeSlash, faFile, faFileArrowUp, faFileDoc, faFileExcel, faFileExport, faFileImage, faFileImport, faFilePdf, faFilePen, faFilePowerpoint, faFileText, faFileWord, faFileXmark, faFileZipper, faFilter, faFilterList, faFloppyDisk, faFolder, faFolderPlus, faFrame, faGalleryThumbnails, faGear, faGridDividers, faGroupArrowsRotate, faHandPointer, faHistory, faHorizontalRule, faImage, faImages, faInfoCircle, faLayerGroup, faLink, faLinkSimpleSlash, faLock, faLockOpen, faMagnifyingGlass, faMagnifyingGlassMinus, faMagnifyingGlassPlus, faMinimize, faMinus, faMoneyCheckDollarPen, faNoteSticky, faObjectGroup, faObjectUngroup, faObjectsAlignBottom, faObjectsAlignTop, faPaperPlane, faPaperPlaneTop, faPaste, faPenCircle, faPenSquare, faPencil, faPlus, faPresentation, faPresentationScreen, faRectangle, faRectangleXmark, faReflectHorizontal, faRefresh, faRegistered, faRotateLeft, faRotateRight, faRows, faSendBack, faShapes, faShare, faShareFromSquare, faShirt, faSidebar, faSitemap, faSort, faSortDown, faSortUp, faSquareMinus, faSquarePlus, faSquareSliders, faSquareSlidersVertical, faStar, faTable, faTelescope, faText, faThumbsDown, faThumbsUp, faTrash, faTrashCan, faTriangle, faUpload, faUser, faUserChart, faUserGroup, faUsersRays, faVideo, faWarning, faWaveSine, faWindowMaximize, faWindowMinimize, faWindowRestore, faXmark } from '@fortawesome/pro-light-svg-icons'
import onVisible from './directives/onVisible'
import tooltip from './directives/tooltip'
import dragScroll from './directives/dragscroll'
import sanitizeHtml from './directives/sanitizeHtml'
import router from './router'
import net from './services/net'
import workerWrapper from './services/workerWrapper'
import auth from './services/auth'
import i18n from './i18n'
import type { AppConfig } from './services/appConfig'
import appConfig from './services/appConfig'
import '@google/model-viewer/dist/model-viewer'
import './styles/index.css'
import './styles/tooltip.css'
import './styles/customFont.css'
import App from './App.vue'

/* import specific icons */

/* add icons to the library */
library.add(faSort, faSortUp, faSortDown, faFilter, faTable, faEllipsisVertical, faRotateLeft, faRotateRight, faFileExport, faFileImage, faFilterList, faXmark, faDatabase, faBookOpenCover, faGroupArrowsRotate, faBell, faMagnifyingGlass, faShirt, faTelescope, faArrowRightFromBracket, faChevronUp, faChevronDown, faChevronLeft, faChevronRight, faUsersRays, faChalkboard, faPlus, faMinus, faSquarePlus, faSquareMinus, faFolderPlus, faTrash, faTrashCan, faCheck, faEdit, faPencil, faPaperPlaneTop, faRefresh, faBinoculars, faAngleDown, faArrowsMaximize, faMinimize, faRectangleXmark, faCopy, faDownload, faStar, faImage, faImages, faInfoCircle, faBarsSort, faSitemap, faColumns, faRows, faGalleryThumbnails, faVideo, faFile, faFilePdf, faFileExcel, faFileWord, faFileDoc, faFilePowerpoint, faFileText, faFileZipper, faSidebar, faGear, faShare, faShareFromSquare, faFileXmark, faAlignLeft, faAlignCenter, faAlignRight, faAlignJustify, faComment, faComments, faLock, faLockOpen, faEllipsisStrokeVertical, faEllipsisStroke, faBringFront, faSendBack, faCheckDouble, faLink, faArrowPointer, faHandPointer, faText, faNoteSticky, faShapes, faFrame, faUpload, faClapperboardPlay, faCloudArrowUp, faCloudArrowDown, faCirclePlus, faAngleDoubleRight, faArrowLeftLong, faCartShopping, faFloppyDisk, faBars, faExclamation, faPaperPlane, faCalendar, faExclamationTriangle, faFolder, faFloppyDisk, faUserChart, faObjectGroup, faObjectUngroup, faUserGroup, faRectangle, faTriangle, faCircle, faHorizontalRule, faSquareSliders, faObjectsAlignTop, faReflectHorizontal, faObjectsAlignBottom, faDistributeSpacingHorizontal, faDistributeSpacingVertical, faSquareSlidersVertical, faPenSquare, faPenCircle, faUser, faPaste, faShare, faMagnifyingGlassPlus, faMagnifyingGlassMinus, faLayerGroup, faThumbsUp, faThumbsDown, faFileImport, faWarning, faFilePen, faFileArrowUp, faWaveSine, faMoneyCheckDollarPen, faChartPie, faWindowMinimize, faWindowMaximize, faWindowRestore, faPresentation, faPresentationScreen, faGridDividers, faRegistered, faCommentEdit, faDash, faEnvelope, faEnvelopeOpen, faClone, faEye, faEyeSlash, faCrop, faLinkSimpleSlash, faHistory, faBookmark, faExchange)

// Load App Config
let config = {} as AppConfig

const p = import.meta.env.DEV
  ? axios.get('/config.local.json').catch(() => {
    return axios.get('/config.json')
  })
  : axios.get('/config.json')

p
  .then((res) => {
    config = res.data
  })
  .catch((err) => {
    console.warn('Failed to load configuration, attempting to get from local storage', err)
    const res = localStorage.getItem('config')
    if (!res) {
      console.error('Unable to load configuration')
    }
    else {
      config = JSON.parse(res)
    }
  })
  .finally(() => {
    if (config && config.AuthUrl) {
      // Set the config in localStorage
      localStorage.setItem('config', JSON.stringify(config))
      // Initialize AppConfig
      appConfig.init(config)
      // Initialize Net
      net.init(config)
      // Initialize DataWorker
      workerWrapper.sendAsync({ id: '', action: 'Init', content: config })
      // Initialize Auth
      auth.init(config)

      // Start App
      const app = createApp(App)

      app.use(i18n)
      if (config.I18nLocale !== i18n.global.locale.value) {
        i18n.global.locale.value = config.I18nLocale
      }
      app.use(router)
      app.use(createPinia())
      app.use(VueResizeObserver)
      app.directive('onVisible', onVisible)
      app.directive('tooltip', tooltip)
      app.component('font-awesome-icon', FontAwesomeIcon)
      app.directive('dragScroll', dragScroll)
      app.directive('sanitize-html', sanitizeHtml)

      Chart.register(...registerables)

      const robotoFont = new FontFace('Roboto', 'url(https://fonts.gstatic.com/s/roboto/v48/KFOMCnqEu92Fr1ME7kSn66aGLdTylUAMQXC89YmC2DPNWubEbVmUiAo.woff2)')

      robotoFont.load().then(() => {
        document.fonts.add(robotoFont)
        app.mount('#app')
      })
    }
  })
